import StartPage from './StartPage';
export default StartPage;
